module.exports = __webpack_public_path__ + "img/arrow-right.c70fa228.png";